import { MultiPolygon, Point, Polygon } from "geojson";
import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { AssetKey, getGeom } from "../assets";

export const rasterRrcSchema = z.object({
  results: z.array(
    z.object({
      start: z.number(),
      end: z.number(),
      max: z.number(),
      t: z.string(),
      td_window: z.string(),
      t_choice: z.number().optional(),
    })
  ),
});

export type RasterRrc = z.infer<typeof rasterRrcSchema>;

export function useRasterRrc(
  uuid: string,
  geometry: Point | Polygon | MultiPolygon,
  assetKey: AssetKey | undefined,
  start: string,
  end: string,
  time_resolution: number
) {
  const geom = getGeom(geometry, assetKey);
  const url = combineUrlAndParams(`/api/v4/rasters/${uuid}/rrc/`, {
    geom,
    start,
    end,
    time_resolution,
  });

  return useParsedQuery<RasterRrc>(
    ["lizard-api-v4", "rasterrrc", url],
    () => fetchWithError(url),
    (json: unknown) => rasterRrcSchema.parse(json),
    {
      enabled: !!uuid,
    }
  );
}
